import errorsFactory from '../../../utils/errorsFactory';
import { VALIDATION_ERRORS } from '../constants';

const isRowEmpty = row => Object.values(row).every(value => !value);

const noEmptyRowsValidator = sheetAsJson => {
  const rowEmptiness = sheetAsJson.map(isRowEmpty);
  const lastNonEmptyRowIndex = rowEmptiness.lastIndexOf(false);
  const containsEmptyRows = rowEmptiness.slice(0, lastNonEmptyRowIndex + 1).some(isRowEmpty => isRowEmpty);

  if (sheetAsJson.length === 0) {
    throw errorsFactory.ValidationError(VALIDATION_ERRORS.WORKSHEET_WIDTH);
  }
  if (containsEmptyRows) {
    throw errorsFactory.ValidationError(VALIDATION_ERRORS.EMPTY_ROWS_ERROR());
  }
};

export default noEmptyRowsValidator;
